<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="订单id" prop="orderId">
                <a-input v-model="queryParam.orderId" placeholder="请输入订单id" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="类型" prop="type">
                <a-select v-model="queryParam.type" placeholder="请选择" allow-clear>
                  <a-select-option :value="0">用户</a-select-option>
                  <a-select-option :value="1">师傅</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="支付类型" prop="bondPayType">
                <a-select v-model="queryParam.bondPayType" placeholder="请选择" allow-clear>
                  <a-select-option :value="0">余额支付</a-select-option>
                  <a-select-option :value="1">微信</a-select-option>
                  <a-select-option :value="2">支付宝</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="支付状态" prop="bondPayStatus">
                <a-select v-model="queryParam.bondPayStatus" placeholder="请选择" allow-clear>
                  <a-select-option :value="1">待支付</a-select-option>
                  <a-select-option :value="2">已支付</a-select-option>
                  <a-select-option :value="3">已取消</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['order:earnestMoneyOrder:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['order:earnestMoneyOrder:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form ref="createForm" @ok="getList" />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="type" slot-scope="text">
          {{ text === 1 ? '师傅' : '用户' }}
        </span>
        <span slot="bondPayType" slot-scope="text">
          {{ bondPayTypeMap[text] != null ? bondPayTypeMap[text] : '-' }}
        </span>
        <span slot="bondPayStatus" slot-scope="text">
          {{ bondPayStatusMap[text] != null ? bondPayStatusMap[text] : '-' }}
        </span>
        <span slot="money" slot-scope="text">
          {{ text != null ? text : '-' }}
        </span>
        <span slot="bondPayDate" slot-scope="text, record">
          {{ parseTime(record.bondPayDate) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['order:earnestMoneyOrder:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['order:earnestMoneyOrder:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['order:earnestMoneyOrder:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { delEarnestMoneyOrder, pageEarnestMoneyOrder } from '@/api/order/earnestMoneyOrder'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

const bondPayTypeMap = { 0: '余额支付', 1: '微信', 2: '支付宝' }
const bondPayStatusMap = { 1: '待支付', 2: '已支付', 3: '已取消' }

export default {
  name: 'EarnestMoneyOrder',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data() {
    return {
      bondPayTypeMap,
      bondPayStatusMap,
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      advanced: false,
      single: true,
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      queryParam: {
        orderId: null,
        type: null,
        bondPayType: null,
        bondPayStatus: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        { title: '订单id', dataIndex: 'id', ellipsis: true, align: 'center', width: 100 },
        { title: '关联订单id', dataIndex: 'orderId', ellipsis: true, align: 'center' },
        { title: '金额', dataIndex: 'money', scopedSlots: { customRender: 'money' }, align: 'center', width: 100 },
        { title: '类型', dataIndex: 'type', scopedSlots: { customRender: 'type' }, align: 'center', width: 80 },
        { title: '支付类型', dataIndex: 'bondPayType', scopedSlots: { customRender: 'bondPayType' }, align: 'center', width: 90 },
        { title: '支付状态', dataIndex: 'bondPayStatus', scopedSlots: { customRender: 'bondPayStatus' }, align: 'center', width: 90 },
        { title: '支付时间', dataIndex: 'bondPayDate', scopedSlots: { customRender: 'bondPayDate' }, align: 'center', width: 160 },
        { title: '创建时间', dataIndex: 'createTime', scopedSlots: { customRender: 'createTime' }, align: 'center', width: 160 },
        { title: '备注', dataIndex: 'remark', ellipsis: true, align: 'center' },
        { title: '操作', dataIndex: 'operation', width: 140, scopedSlots: { customRender: 'operation' }, align: 'center' }
      ]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      pageEarnestMoneyOrder(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = {
        orderId: undefined,
        type: undefined,
        bondPayType: undefined,
        bondPayStatus: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    handleDelete(row) {
      const that = this
      const ids = row.id != null ? [row.id] : this.ids
      if (row.id != null) {
        this.ids = [row.id]
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk() {
          const data = that.ids.map(id => ({ id }))
          return delEarnestMoneyOrder(data).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {
          that.ids = that.selectedRows.map(item => item.id)
        }
      })
    }
  }
}
</script>
